export default "__VITE_ASSET__Cxm9lTGO__"